module.exports = __webpack_public_path__ + "img/logo.1e37357b.png";